module.exports = __webpack_public_path__ + "static/media/Binance.cccd0006.svg";